import { motion } from 'motion/react'
import type { ReactNode } from 'react'
import { cn } from '~/lib/utils'
import { fadeInStagger } from '~/lib/utils/animations'

type SectionProps = {
  title?: string
  subtitle?: string
  children: ReactNode
  className?: string
  containerClassName?: string
  titleClassName?: string
  subtitleClassName?: string
  dark?: boolean
}

export const Section = ({
  title,
  subtitle,
  children,
  className = '',
  containerClassName = '',
  titleClassName = '',
  subtitleClassName = '',
  dark = false,
}: SectionProps) => {
  return (
    <section
      className={cn(
        'relative py-24',
        dark && 'bg-[#001871] text-white',
        !dark && 'bg-white',
        className
      )}
    >
      {dark && (
        <>
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?ixlib=rb-4.0.3')] opacity-5 mix-blend-soft-light"></div>
          <div className="absolute inset-0 bg-linear-to-b from-[#001871] via-[#001871] to-[#001871]/90"></div>
        </>
      )}

      <div className={cn('relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8', containerClassName)}>
        {(title || subtitle) && (
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={fadeInStagger()}
            className="mb-16 text-center"
          >
            {title && (
              <h2
                className={cn(
                  'mb-4 text-4xl font-bold tracking-tight sm:text-5xl',
                  dark ? 'text-white [text-shadow:0_1px_2px_rgb(0_0_0/20%)]' : 'text-[#001871]',
                  titleClassName
                )}
              >
                {title}
              </h2>
            )}
            {subtitle && (
              <p
                className={cn(
                  'text-xl',
                  dark ? 'text-white/90' : 'text-gray-600',
                  subtitleClassName
                )}
              >
                {subtitle}
              </p>
            )}
          </motion.div>
        )}
        {children}
      </div>
    </section>
  )
}
